import { render, staticRenderFns } from "./EmployerMassTransitSettings.vue?vue&type=template&id=fd1bb674&scoped=true"
import script from "./EmployerMassTransitSettings.vue?vue&type=script&lang=ts"
export * from "./EmployerMassTransitSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1bb674",
  null
  
)

export default component.exports